import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Instagram, Facebook } from 'lucide-react';
import { navLinks, LOGO_URL } from './data';
import { PayButton } from './PayButton';
export function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className="fixed top-0 inset-x-0 z-50 bg-[#faf0e7] transition-shadow duration-500 shadow-[0_1px_18px_rgba(44,33,24,0.05)]" data-id="element-273" data-mp="ejnyorqtzet4">
      <nav className="max-w-6xl mx-auto px-5 sm:px-8 flex items-center justify-between h-[4.5rem] sm:h-24" data-id="element-274" data-mp="9j011n83jzpx">
        <a href="#inicio" className="flex items-center" aria-label="Ginger Briones Studio inicio" data-id="element-275" data-mp="1q0nq7l5ctpm3">
          <img src={LOGO_URL} alt="Ginger Briones Studio" className="h-16 sm:h-20 w-auto object-contain [mix-blend-mode:darken]" data-id="element-276" data-mp="1l1kjzxdn1dcj" />
        </a>

        <ul className="hidden md:flex items-center gap-8" data-id="element-277" data-mp="en151iz4ypia">
          {navLinks.map(link => <li key={link.href} data-id="element-278" data-mp="jmx1mx5i7ent">
              <a href={link.href} className="font-body text-[11px] tracking-[2px] uppercase text-mid transition-colors duration-300 hover:text-gold" data-id="element-279" data-mp="jnoyscer1kg7">
                {link.label}
              </a>
            </li>)}
        </ul>

        <div className="hidden md:flex items-center gap-3" data-id="element-280" data-mp="3n57349vbc9bv">
          <SocialIcon href="https://www.instagram.com/gbstudiony/" label="Instagram" scrolled={true} data-id="element-281" data-mp="3s1nudcxt73t6">
            <Instagram className="w-4 h-4" strokeWidth={1.5} data-id="element-282" data-mp="v4jxyvvxfve" />
          </SocialIcon>
          <SocialIcon href="https://www.facebook.com/GingerBrionesC5/?ref=PROFILE_EDIT_xav_ig_profile_page_web#" label="Facebook" scrolled={true} data-id="element-283" data-mp="5ne7x9dfw5v1">
            <Facebook className="w-4 h-4" strokeWidth={1.75} data-id="element-284" data-mp="34cmfp7yduwfg" />
          </SocialIcon>
          <PayButton label="Pagar" data-id="element-285" data-mp="39aehctotxwwu" />
        </div>

        <div className="flex items-center gap-1.5 md:hidden" data-id="element-286" data-mp="31b024n9p0itn">
          <a href="https://www.instagram.com/gbstudiony/" aria-label="Instagram" className="p-2 text-champagne-deep transition-colors hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne-deep focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-287" data-mp="319go73biejv1">
            <Instagram className="w-4 h-4" strokeWidth={1.5} data-id="element-288" data-mp="362rsoxsumojs" />
          </a>
          <a href="https://www.facebook.com/GingerBrionesC5/?ref=PROFILE_EDIT_xav_ig_profile_page_web#" aria-label="Facebook" className="social-icon-elevation flex h-8 w-8 items-center justify-center rounded-full text-champagne-deep transition-colors hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne-deep focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-289" data-mp="2id70doat2exu">
            <Facebook className="w-4 h-4" strokeWidth={1.75} data-id="element-290" data-mp="7ijaa60gtt77" />
          </a>
          <PayButton label="Pagar" className="ml-1" data-id="element-291" data-mp="2k83631k1wso" />
          <button onClick={() => setOpen(true)} className="p-2 text-dark transition-colors hover:text-champagne-deep focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne-deep focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" aria-label="Abrir menú" data-id="element-292" data-mp="a4sctm4asl43">
            <Menu className="w-6 h-6" strokeWidth={1.5} data-id="element-293" data-mp="16grnzm7afj1" />
          </button>
        </div>
      </nav>

      <AnimatePresence data-id="element-294" data-mp="57ipcc0gyjiw">
        {open && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setOpen(false)} className="fixed inset-0 bg-dark/40 backdrop-blur-sm z-40 md:hidden" data-id="element-295" data-mp="swbftsybnz64" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'tween',
          duration: 0.35,
          ease: [0.22, 1, 0.36, 1]
        }} className="fixed top-0 right-0 bottom-0 w-[78%] max-w-xs bg-cream z-50 md:hidden flex flex-col p-7" data-id="element-296" data-mp="k15eb663439e">
              <div className="flex items-center justify-between mb-10" data-id="element-297" data-mp="3p2qalg3g65fn">
                <img src={LOGO_URL} alt="Ginger Briones Studio" className="h-14 w-auto object-contain [mix-blend-mode:darken]" data-id="element-298" data-mp="3k2axmpn2uzy7" />
                <button onClick={() => setOpen(false)} className="p-2 text-mid" aria-label="Cerrar menú" data-id="element-299" data-mp="3f4j0nh7ksnn5">
                  <X className="w-6 h-6" strokeWidth={1.5} data-id="element-300" data-mp="3b3qoaf3eq2mn" />
                </button>
              </div>

              <ul className="flex flex-col gap-1" data-id="element-301" data-mp="bm95em8d0p7j">
                {navLinks.map((link, i) => <motion.li key={link.href} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.1 + i * 0.06
            }} data-id="element-302" data-mp="6p8zqcff9ogy" data-mpi={i}>
                    <a href={link.href} onClick={() => setOpen(false)} className="block py-3 font-serif text-2xl text-dark hover:text-gold transition-colors border-b border-brand-border/50" data-id="element-303" data-mp="udiit6l93y4e">
                      {link.label}
                    </a>
                  </motion.li>)}
              </ul>

              <div className="mt-auto flex items-center gap-4 pt-8" data-id="element-304" data-mp="2d8mvgm15n5pf">
                <a href="https://www.instagram.com/gbstudiony/" aria-label="Instagram" className="w-11 h-11 rounded-full border border-champagne-deep/60 flex items-center justify-center text-champagne-deep hover:bg-champagne hover:text-dark transition-colors" data-id="element-305" data-mp="2d8wnef5rfmxr">
                  <Instagram className="w-5 h-5" strokeWidth={1.5} data-id="element-306" data-mp="2r7cwgcr3hpj2" />
                </a>
                <a href="https://www.facebook.com/GingerBrionesC5/?ref=PROFILE_EDIT_xav_ig_profile_page_web#" aria-label="Facebook" className="social-icon-elevation flex h-11 w-11 items-center justify-center rounded-full border border-champagne-deep/60 text-champagne-deep transition-colors hover:bg-champagne hover:text-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne-deep focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-307" data-mp="2w6phqt2biojj">
                  <Facebook className="w-5 h-5" strokeWidth={1.75} data-id="element-308" data-mp="1evqv5clwggnq" />
                </a>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </header>;
}
function SocialIcon({
  href,
  label,
  scrolled,
  children
}: {
  href: string;
  label: string;
  scrolled: boolean;
  children: React.ReactNode;
}) {
  const baseClassName = 'flex h-9 w-9 items-center justify-center rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne-deep focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]';
  const appearanceClassName = scrolled ? 'text-champagne-deep transition-colors duration-300 hover:text-champagne' : 'text-warm-white transition-colors duration-300 hover:text-gold-light';
  return <a href={href} aria-label={label} className={`${baseClassName} ${appearanceClassName}`} data-id="element-309" data-mp="22lv1hrqh2uif">
      {children}
    </a>;
}